export default {
  auth: () => import("/usr/src/app/layouts/auth.vue"),
  default: () => import("/usr/src/app/layouts/default.vue"),
  editor: () => import("/usr/src/app/layouts/editor.vue")
}